module.exports = __webpack_public_path__ + "static/media/icon_avatar.06dd104a.svg";